import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'react-bootstrap';
import FieldGroup from './FieldGroup';
import FormTitle from './FormTitle';
import ToggleCheckbox from '../Controls/ToggleCheckbox';
import { formatClassName, pickDataAttributes } from '../../Util';
import noop from '../../util/noop';

/** renders a form section */
const FormSection = ({
  children,
  className,
  data,
  defaultExpanded,
  description,
  isCard,
  onToggle = noop,
  title,
  toggle,
  ...props
}) => {
  const [toggled, setToggled] = useState(() => {
    return !toggle || (data && data[toggle.name]) || toggle.checked
  });

  useEffect(() => {
    onToggle(toggled)
  }, []);

  useEffect(() => {
    if (toggle && toggle.checked !== toggled){
      setToggled(toggle.checked);
    }
  }, [toggle])

  const handleToggle = value => {
    setToggled(value);
    onToggle(value);
  };

  const sectionClassName = formatClassName([
    'form-section',
    className,
    { 'form-section-card': isCard }
  ]);

  const inner = (
    <FieldGroup {...props} data={data} className={sectionClassName}>
      {toggle && <ToggleCheckbox
        {...pickDataAttributes(toggle)}
        className={`round sm ${toggle.style}`}
        checked={toggled}
        label={toggle.label}
        name={toggle.name}
        onChange={event => { handleToggle(event.target.checked) }}
      />}
      {title && <FormTitle className={description ? 'with-description' : ''}>
        {title}
      </FormTitle>}
      {description && <p className="form-section-description">{description}</p>}
      <Collapse in={toggled}>
        <FieldGroup {...props} data={data}>
          {children}
        </FieldGroup>
      </Collapse>
    </FieldGroup>
  );

  if (isCard) {
    return (
      <div className="card presentation-card presentation-card-extra-wide">
        <div className="card-main-container">
          {inner}
        </div>
      </div>
    );
  } else {
    return inner;
  }
};

FormSection.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  data: PropTypes.object,
  defaultExpanded: PropTypes.bool,
  description: PropTypes.string,
  isCard: PropTypes.bool,
  onToggle: PropTypes.func,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]).isRequired,
  toggle: PropTypes.shape({
    checked: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string,
    defaultChecked: PropTypes.bool,
    style: PropTypes.oneOf(["default", "primary", "secondary"])
  })
};

export default FormSection;
